<template>
    <div>
        <Logo class="mb-5" />
        <form @submit.stop.prevent="signin">
            <div class="form-floating">
                <input type="text" name="login" class="form-control" required v-model="login" placeholder="Login" />
                <label for="login">Login</label>
            </div>
            <div class="form-floating">
                <input type="password" class="form-control" required v-model="senha" placeholder="Senha" />
                <label for="senha">Senha</label>
            </div>
            <button class="w-100 btn btn-lg btn-primary mt-2" type="submit" v-if="!loading">
                Entrar
            </button>
            <button class="w-100 btn btn-lg btn-primary mt-2" type="submit" v-else>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Carregando...
            </button>
        </form>
    </div>
</template>
<script setup lang="ts">
import Logo from '@/assets/logo-color.svg'
import { onMounted, onUnmounted, ref } from "vue"
import { auth_service } from '../../store/auth'
import { useRouter } from 'vue-router'
import Swal from 'sweetalert2'

onMounted(() => {
    document.body.classList.add("login-page")
    document.body.querySelector("div.app")?.classList.add("form-signin")
})
onUnmounted(() => {
    document.body.classList.remove("login-page")
    document.body.querySelector("div.app")?.classList.remove("form-signin")
})

const login = ref<string>('')
const senha = ref<string>('')
const loading = ref<boolean>(false)

const $router = useRouter()

const signin = async () => {
    try {
        loading.value = true;
        await auth_service.login({
            login: login.value,
            senha: senha.value
        })

        $router.replace('/');

    } catch (err) {
        let text = 'Não foi possível enviar o formulário';
        if (err instanceof Error) {
            text = err.message
        }
        Swal.fire({
            icon: 'error',
            title: 'Oops',
            text
        });
    }
    loading.value = false;
}

</script>
<style lang="less" scoped>
svg {
    font-size: 4rem;
}
</style>
<style lang="less">
body {
    &.login-page {
        text-align: center;
        display: flex;
        align-items: center;
        padding-top: 40px;
        padding-bottom: 40px;
        background-color: #f5f5f5;

        .form-signin {
            width: 100%;
            max-width: 330px;
            padding: 15px;
            margin: auto;

            .form-floating:focus-within {
                z-index: 2;
            }
        }
    }
}

input[name="login"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

input[type="password"] {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}

select {
    margin-bottom: -1px;
    border-radius: 0;
}
</style>